var _defs, _circle, _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownbutton01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009444;}.cls-2{fill:#874713;}.cls-3{fill-rule:evenodd;fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1180.97,
    y1: -365.24,
    x2: 1180.97,
    y2: -436.42,
    gradientTransform: "matrix(0, 1, 1, 0, 462.33, -1110.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7dbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaedff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.5,
    cy: 62.5,
    r: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.5,18A44.5,44.5,0,1,1,17,62.5,44.5,44.5,0,0,1,61.5,18m0-7A51.5,51.5,0,1,0,113,62.5,51.55,51.55,0,0,0,61.5,11Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "35.26 46.95 25.91 56.74 61.5 93.3 97.09 56.74 87.74 46.95 61.5 63.6 35.26 46.95 35.26 46.95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownbutton01);
export default __webpack_public_path__ + "static/media/Drop down button-01.e4cc9e3268e0ee5b53210004655ad858.svg";
export { ForwardRef as ReactComponent };